const config = {
  wordPressURL: `https://gatsby.tiborpaulsch.nl/`,
}

export default config
